<template>
    <div>
        <modal :show.sync="addProduct" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Agregar jornal o salario/pensión</h6>
                <div class="form-group">
                    <label>Jornales o salario/pensión *</label>
                    <fg-input   tabindex="1"
                                name="jornales o salario"
                                v-validate="modelValidations.salaryName"
                                :error="getError('jornales o salario')"
                                v-model="salaryName">
                            <el-select
                                    class="select-warning"
                                    size="large"
                                    placeholder="Seleccione..."
                                    v-model="salaryName">
                            <el-option
                                    class="select-warning"
                                    value="Jornales"
                                    label="Jornales">
                            </el-option>
                            <el-option
                                    class="select-warning"
                                    value="Salario/pensión"
                                    label="Salario/pensión">
                            </el-option>
                        </el-select>
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Valor *</label>
                    <vue-numeric  :max=999999999 tabindex="2" currency="$" autocomplete="off" name="valor" v-validate="modelValidations.item_value" :error="getError('valor')" separator="." class="form-control" v-model="salaryValue"></vue-numeric>
                    <span v-show="errors.has('valor')" class="text-danger" style="font-size: 11px;">
                        {{ errors.first('valor') }}
                    </span>
                </div>
                <div class="form-group">
                    <label>Observaciones </label>
                    <textarea   class="form-control"
                                tabindex="3"
                                type="text"
                                name="observaciones"
                                autocomplete="off"
                                placeholder="observaciones"
                                v-validate="modelValidations.salaryObservations"
                                :error="getError('observaciones')"
                                v-model="salaryObservations">
                    </textarea>
                    <span v-show="errors.has('observaciones')" class="text-danger" style="font-size: 11px;">
                        {{ errors.first('observaciones') }}
                    </span>
                </div>
            <template slot="footer">
                <div class="left-side">
                <p-button type="default" link @click="cancelAddProduct()">Cancelar</p-button>
                </div>
                <div class="divider"></div>
                <div class="right-side">
                <p-button type="default" link @click="addProductToList()">Agregar</p-button>
                </div>
            </template>
        </modal>
        <modal :show.sync="editProduct" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Editar jornal o salario/pensión</h6>
            <div class="form-group">
                    <label>Jornales o salario/pensión *</label>
                    <fg-input   tabindex="1"
                                name="jornales o salario"
                                v-validate="modelValidations.salaryName"
                                :error="getError('jornales o salario')"
                                v-model="salaryName">
                            <el-select
                                    class="select-warning"
                                    size="large"
                                    placeholder="Seleccione..."
                                    v-model="salaryName">
                            <el-option
                                    class="select-warning"
                                    value="Jornales"
                                    label="Jornales">
                            </el-option>
                            <el-option
                                    class="select-warning"
                                    value="Salario/pensión"
                                    label="Salario/pensión">
                            </el-option>
                        </el-select>
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Valor *</label>
                    <vue-numeric  :max=999999999 tabindex="2" currency="$" autocomplete="off" name="valor" v-validate="modelValidations.item_value" :error="getError('valor')" separator="." class="form-control" v-model="salaryValue"></vue-numeric>
                    <span v-show="errors.has('valor')" class="text-danger" style="font-size: 11px;">
                        {{ errors.first('valor') }}
                    </span>
                </div>
                <div class="form-group">
                    <label>Observaciones </label>
                    <textarea   class="form-control"
                                tabindex="3"
                                type="text"
                                name="observaciones"
                                autocomplete="off"
                                placeholder="observaciones"
                                v-validate="modelValidations.salaryObservations"
                                :error="getError('observaciones')"
                                v-model="salaryObservations">
                    </textarea>
                    <span v-show="errors.has('observaciones')" class="text-danger" style="font-size: 11px;">
                        {{ errors.first('observaciones') }}
                    </span>
                </div>
            <template slot="footer">
                <div class="left-side">
                <p-button type="default" link @click="cancelEditProduct()">Cancelar</p-button>
                </div>
                <div class="divider"></div>
                <div class="right-side">
                <p-button type="default" link @click="editProductToList()">Editar</p-button>
                </div>
            </template>
        </modal>
        <div class="col-md-12 mb-2">
                <h4 class="title center-title">Hoja de trabajo</h4>
        </div>
        <!-- Inventory -->
        <card  class="form-horizontal">
            <div class="card-header">
                <h6 class="card-title">JORNALES O SALARIO PENSIÓN</h6>
            </div>
            <div class="card-body">
                <el-table v-if="products.length" :data="products"  ref="productsTable"  highlight-current-row @current-change="handleCurrentChange">
                    <el-table-column type="expand">
                        <template slot-scope="props">
                            <p>Descripción: {{ props.row.salaryObservations }}</p>
                        </template>
                    </el-table-column>
                    <el-table-column label="Item" property="salaryName"></el-table-column>
                    <el-table-column label="Total">
                        <template slot-scope="scope">
                            <span >{{ setFormat(scope.row.salaryValue )}}</span>
                        </template>
                    </el-table-column>
                </el-table>
                
                <div>
                    <p-button 
                        @click="addProductMethod()"
                        type="default" 
                        >
                        <i class="mr-2 fa fa-plus"></i>Agregar jornal o salario/pensión
                    </p-button>
                    <br>
                    <p-button v-if="currentRow"
                        @click="editProductMethod()"
                        type="default" 
                        >
                        <i class="mr-2 fa fa-pencil"></i>Editar jornal o salario/pensión
                    </p-button>
                    <br>
                    <p-button v-if="currentRow"
                        @click="removeProductMethod()"
                        type="default" 
                        >
                        <i class="mr-2 fa fa-minus"></i>Quitar jornal o salario/pensión
                    </p-button>
                </div>
            </div>
            <div class="card-footer">
                <div v-if="totalSalary != 0" class="alert alert-warning mt-2">
                    <span>Valor total Jornales o Salario Pensión: {{ setFormat(totalSalary)}}</span>
                </div>
            </div>
        </card>
        <div class="text-right">
            <p-button @click="saveData()" type="warning">Siguiente</p-button>
            <p-button @click="toMenu()" type="default" class="pull-left mb-3">Atrás</p-button>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue'
    import swal from 'sweetalert2'
    import { Card, Collapse, CollapseItem, Modal } from 'src/components/UIComponents'
    import PSwitch from 'src/components/UIComponents/Switch.vue'
    import VueNumeric from 'vue-numeric'
    import formatMoney from 'accounting-js/lib/formatMoney.js'
    import {Select, Option, Table, TableColumn} from 'element-ui'
    import Expenses from 'src/util/Others/OperatingExpenses'
    import Taxes from 'src/util/Services/Taxes'
    import moment from 'moment'
    Vue.use(Table)
    Vue.use(TableColumn)
    Vue.use(Select)
    Vue.use(Option)
    export default {
        components: {
            Card,
            PSwitch,
            VueNumeric,
            Collapse,
            CollapseItem,
            Modal
        },
        data() {
        return {
            cashFlowData: null,
            sumSalaries: 0,
            sumJournals: 0,
            sumConsolidatedSalaries: 0,
            sumConsolidatedJournals: 0,
            form: {
                average_selection: '',
            },
            operatingSwitches: {
                expenses: false,
                inventory: false,
            },
            microcredit: false,
            consumer: false,
            pyme: false,
            expenses : [],
            actualExpenses: [],
            currentRow: null,
            addExpense: false,
            editExpense: false,
            addExpenseIndex: null,
            addProduct: false,
            editProduct: false,
            addProductIndex: null,
            monthlyNumber: '',
            expenseName: '',
            expenseValue: '',
            expenseLocked: false,
            salaryName: '',
            salaryValue: '',
            salaryObservations: '',
            referenceDescription: '',
            products: [
                
            ],
            costs: [],
            average: {
                good_sale: '',
                bad_sale: '',
                regular_sale: '',
                average_sales: '',
                monthly_average_sales: ''
            },
            modelValidations: {
                item_value: {
                    required: true
                },
                item_name: {
                    required: true,
                    max: 32
                },
                item_qty: {
                    required: true,
                    max: 9
                },
                salaryName: {
                    required: true
                },
                salaryObservations: {
                    max: 200
                }
            },
        }
        },
        watch: {
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             products: {
                handler(newProducts) {
                    let sumSalaries = 0;
                    let sumJournals = 0;

                    newProducts.forEach(product => {
                        if (product.salaryName === 'Jornales') {
                            sumJournals += product.salaryValue || 0;
                        } else if (product.salaryName === 'Salario/pensión') {
                            sumSalaries += product.salaryValue || 0;
                        }
                    });

                    this.sumSalaries = sumSalaries;
                    this.sumJournals = sumJournals;

                    // Verificar si cashFlowData y cashFlowData.months existen antes de usar su longitud
                    const monthsLength = (this.cashFlowData && this.cashFlowData.months) ? this.cashFlowData.months.length : 0;

                    this.sumConsolidatedSalaries = sumSalaries * monthsLength;
                    this.sumConsolidatedJournals = sumJournals * monthsLength;
                },
                deep: true, // Observa cambios dentro del array
                immediate: true // Ejecuta el cálculo al inicio
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            'operatingSwitches.expenses': function (newVal, oldVal) {
                if (!newVal) {
                    this.actualExpenses = [];
                    for (let i=0; i<this.expenses.length;i++) {
                        this.actualExpenses.push({
                            id: this.expenses[i].id,
                            name: this.expenses[i].name,
                            value: 0,
                            locked: true
                        })
                    }
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            'operatingSwitches.inventory': function (newVal, oldVal) {
                if (!newVal) {
                    this.products = []
                }
            },
        },
        computed: {
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            verifyNext () {
                if (!this.operatingSwitches.expenses && !this.operatingSwitches.inventory) {
                    return true
                }
                else if(this.operatingSwitches.expenses && this.operatingSwitches.inventory &&  this.allExpensesMonthlyCostComputed != 0 && this.totalSalary != 0) {
                    return true
                }
                else if(this.operatingSwitches.expenses  &&  this.allExpensesMonthlyCostComputed ) {
                    if(!this.operatingSwitches.inventory) {
                        return true
                    }
                }
                else if(this.operatingSwitches.inventory  &&  this.totalSalary ) {
                    if(!this.operatingSwitches.expenses) {
                        return true
                    }
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            productCostTotalComputed() {
                var total = this.productQuantity * this.productSaleUnity;
                this.productCostTotal = total;
                return total;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            totalSalary() {
                var sum = 0;
                for (let i = 0;i<this.products.length;i++) {
                    sum = sum + this.products[i].salaryValue; 
                }
                return sum
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            productMonthlyCostComputed() {
                var total = 0;
                if (this.monthlyNumber != '') {
                    var total = this.productQuantity * this.productCostUnity * this.monthlyNumber;
                    this.productMonthlyCost = total;
                }
                return total;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            allExpensesMonthlyCostComputed() {
                var sum = 0;
                for (let i=0;i<this.actualExpenses.length;i++) {
                    sum = sum + (this.actualExpenses[i].value);
                }
                return sum   
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            allCostsComputed() {
                return this.allExpensesMonthlyCostComputed
            }
        },
        methods: {
            toMenu () {
                this.$router.push('/asessments/menu');
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            productValidator (product) {
                if (this.$store.state.isCustomer) {
                    if (product.name.toLowerCase() == 'consumo') {
                        this.consumer = true;
                        this.microcredit = false;
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].references.length != 0) {
                            this.products = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].references;
                            
                        }
                    }
                    else if (product.name.toLowerCase() == 'microcrédito' || product.name.toLowerCase() == 'microcredito') {
                        this.microcredit = true;
                        this.consumer = false;
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].costsPopulate && this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].references.length != 0) {
                            this.products = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].references;
                            
                        }
                    }
                    else if (product.name.toLowerCase() == 'pequeña empresa') {
                        this.microcredit = false;
                        this.consumer = false;
                        this.pyme = true;
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].costsPopulate && this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].references.length != 0) {
                            this.products = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].references;
                            
                        }
                    }
                    
                }
                else if(this.$store.state.isSpouse) {
                    if (product.name.toLowerCase() == 'consumo') {
                        this.consumer = true;
                        this.microcredit = false;
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].references.length != 0) {
                            this.products = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].references;
                            
                        }
                    }
                    else if (product.name.toLowerCase() == 'microcrédito' || product.name.toLowerCase() == 'microcredito') {
                        this.microcredit = true;
                        this.consumer = false;
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].costsPopulate && this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].references.length != 0) {
                            this.products = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].references;
                            
                        }
                    }
                    else if (product.name.toLowerCase() == 'pequeña empresa') {
                        this.microcredit = false;
                        this.consumer = false;
                        this.pyme = true;
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].costsPopulate && this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].references.length != 0) {
                            this.products = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].references;
                            
                        }
                    }
                    
                }
                if (this.$store.state.isGuarantor) {
                    if (product.name.toLowerCase() == 'consumo') {
                        this.consumer = true;
                        this.microcredit = false;
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].references.length != 0) {
                            this.products = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].references;
                            
                        }
                    }
                    else if (product.name.toLowerCase() == 'microcrédito' || product.name.toLowerCase() == 'microcredito') {
                        this.microcredit = true;
                        this.consumer = false;
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].costsPopulate && this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].references.length != 0) {
                            this.products = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].references;
                            
                        }
                    }
                    else if (product.name.toLowerCase() == 'pequeña empresa') {
                        this.microcredit = false;
                        this.consumer = false;
                        this.pyme = false;
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].costsPopulate && this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].references.length != 0) {
                            this.products = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].references;
                            
                        }
                    }
                    
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            handleCurrentChange(currentRow, oldCurrentRow) {
                this.currentRow = currentRow;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            editExpenseToList () {
                if (this.expenseName == '') {
                    this.showNotificationError('El campo nombre de gasto no puede estar vacío');
                }
                else {
                    var index = this.actualExpenses.indexOf(this.currentRow);
                    this.actualExpenses[index].name = this.expenseName;
                    this.actualExpenses[index].value = this.expenseValue;
                    this.resetExpense();
                    this.currentRow = null;
                    this.$refs.expensesTable.setCurrentRow();
                    this.editExpense = false;
                    this.showNotificationSuccess('Gasto editado correctamente');
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addExpenseMethod (row) {
                // this.addProductIndex = row;
                this.addExpense = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            handleCurrentChange(currentRow, oldCurrentRow) {
                this.currentRow = currentRow;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addProductToList () {
                this.$validator.validateAll().then(isValid => {
                    if(isValid){
                        this.products.push({
                            salaryName: this.salaryName,
                            salaryValue: this.salaryValue,
                            salaryObservations: this.salaryObservations
                        })
                        this.resetProduct();
                        this.addProduct = false;
                        this.errors.clear();
                        this.showNotificationSuccess('Jornal o salario/pensión agregado correctamente');
                        }
                        else {
                            console.error('Error: Campos no diligenciados correctamente');
                            console.log('Errores de validación:', this.errors.items); // Muestra los errores específicos
                            this.errors.items.forEach(error => {
                                console.log(`Campo: ${error.field}, Mensaje: ${error.msg}`);
                            });
                            this.showNotificationError('Campos no diligenciados correctamente');
                        }
                })

            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            resetProduct () {
                this.salaryName = '';
                this.salaryValue = '';
                this.salaryObservations = '';
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            editProductMethod () {
                this.salaryName= this.currentRow.salaryName;
                this.salaryValue= this.currentRow.salaryValue;
                this.salaryObservations= this.currentRow.salaryObservations;
                this.editProduct = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            removeProductMethod () {
                this.products.splice(this.products.indexOf(this.currentRow),1);
                this.currentRow = null;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            editProductToList () {
                this.$validator.validateAll().then(isValid => {
                    if(isValid){
                            var index = this.products.indexOf(this.currentRow);
                            this.products[index].salaryName = this.salaryName;
                            this.products[index].salaryValue = this.salaryValue;
                            this.products[index].salaryObservations = this.salaryObservations;
                            this.resetProduct();
                            this.currentRow = null;
                            this.$refs.productsTable.setCurrentRow();
                            this.editProduct = false;
                            this.errors.clear();
                            this.showNotificationSuccess('Jornal o salario/pensión editado correctamente');
                        }
                })
                
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addProductMethod (row) {
                this.addProductIndex = row;
                this.errors.clear();
                this.addProduct = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            cancelAddProduct () {
                this.addProduct = false;
                this.errors.clear();
                this.resetProduct();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            cancelEditProduct () {
                this.editProduct = false;
                this.errors.clear();
                this.resetProduct();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            resetItem () {
                this.itemName = '';
                this.itemPurchasePrice = '';
                this.itemSalePrice = '';
                this.itemPercent = '';
                this.productName= '';
                this.productQuantity= '';
                this.productCostUnity= '';
                this.productSaleUnity= '';
                this.productCostTotal= '';
                this.productMonthlyCost= '';
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            showNotificationError (message) {
                this.$notify(
                {
                    message: message,
                    icon: 'nc-icon nc-glasses-2',
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'danger'
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            showNotificationSuccess (message) {
                this.$notify(
                {
                    message: message,
                    icon: 'nc-icon nc-check-2',
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'success'
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addExpenseToList () {
                if (this.expenseName == '') {
                    this.showNotificationError('El campo nombre de gasto no puede estar vacío');
                }
                else {
                    var id = this.actualExpenses.length + 1;
                    this.actualExpenses.push({
                        id: id,
                        name: this.expenseName,
                        value: this.expenseValue,
                        locked: false
                    })
                    this.resetExpense();
                    this.addExpense = false;
                    this.showNotificationSuccess('Gasto agregado correctamente');
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            resetExpense () {
                this.expenseName = '';
                this.expenseValue = '';   
                this.expenseLocked = false;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            addProductMethod () {
                this.addProduct = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            editExpenseMethod () {
                this.expenseName= this.currentRow.name;
                this.expenseValue= this.currentRow.value;
                this.expenseLocked = this.currentRow.locked;
                this.editExpense = true;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            removeExpenseMethod () {
                this.actualExpenses.splice(this.actualExpenses.indexOf(this.currentRow),1);
                this.currentRow = null;
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            cancelAddExpense () {
                this.addExpense = false;
                this.resetExpense();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            cancelEditExpense () {
                this.editExpense = false;
                this.resetExpense();
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            setFormat (value) {
                return formatMoney(value, { symbol: "$", precision: 0, thousand: ".", decimal: "," });
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            getError (fieldName) {
                return this.errors.first(fieldName)
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            toSalesCostsSelection () {
                this.$router.push('/asessments/new_asessment/customer/sales_costs_selection');
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            toOperatingExpenses () {
                this.$router.push('/asessments/new_asessment/customer/others/operating_expenses');
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            toRequestData () {
                this.$router.push('/asessments/new_asessment/customer/request_data');
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             saveData () {
                if (this.products.length != 0) {
                    const payload = {
                        products: this.products,
                        sumSalaries: this.sumSalaries,
                        sumJournals: this.sumJournals,
                        sumConsolidatedSalaries: this.sumConsolidatedSalaries,
                        sumConsolidatedJournals: this.sumConsolidatedJournals,
                        totalSalary: this.totalSalary
                    };
                    this.$store.dispatch('setAgroSalary', payload).then(()=>{
                        this.$router.push('/asessments/new_asessment/customer/agro/expenses');
                    });
                }
                else {
                    this.showNotificationError('Debe ingresar datos de venta de productos almacenados');
                    // this.$router.push('/asessments/new_asessment/customer/others/additional_information');
                }
            }
        },
        mounted () {
            if (this.$store.state.isCustomer) {
                if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].agroData.salary) {
                    this.products = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].agroData.salary;
                }
                this.cashFlowData = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].agroData.cashFlowData;
            }
            else if (this.$store.state.isSpouse) {
                if (this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].agroData.salary) {
                    this.products = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].agroData.salary;
                }
                this.cashFlowData = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.actualStudy].agroData.cashFlowData;
            }
            else if (this.$store.state.isGuarantor) {
                if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].agroData.salary) {
                    this.products = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].agroData.salary;
                }
                this.cashFlowData = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies[this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[this.$store.state.assesments[this.$store.state.actualAssesment].actualGuarantors].studies.length - 1].agroData.cashFlowData;
            }
        }
    }
</script>
<style lang="scss">
// Estilos para poder centrar el título de el usuario
    .center-title {
        margin-top: 0;
        margin-bottom: 0;
    }
</style>
